<c-card *transloco="let t">
  <c-card-body class="px-2">
    <c-row>
      <c-col md="12" lg="6">
        <h1>{{ t('Manage Devices') }}</h1>
      </c-col>
      <c-col md="12" lg="6" class="text-end">
        <div class="btn-group mb-2" role="group">
          <button cButton class="btn btn-light" type="button" data-bs-toggle="modal" data-bs-target="#deviceUploadModal" (click)="openUploadModal()">
            <i class="fa-solid fa-upload"></i> {{ t('Upload Devices') }}
          </button>
          <button cButton class="btn btn-light" type="button" (click)="exportDevices()">
            <i class="fa-solid fa-file-excel"></i> {{ t('Export Devices') }}
          </button>
        </div>
        &nbsp;
        <button cButton class="btn btn-success text-white mb-2" type="button" (click)="openAddForm()">
          <i class="fa-solid fa-plus"></i> {{ t('Add Device') }}
        </button>
      </c-col>
    </c-row>

    <c-row>
      <c-col>
        <div class="alert alert-info">
          {{ t('Manage Zoleo account devices. Add, edit, search and remove devices for this company.') }}
        </div>
      </c-col>
    </c-row>

    <c-card *ngIf="showForm" class="mb-2">
      <c-card-body>
        <h5>{{ editingId ? t('Edit Device') : t('Add Device') }}</h5>
        <form cForm [formGroup]="deviceForm" (ngSubmit)="saveDevice()">
          <c-row class="mb-2">
            <c-col md="6">
              <label cLabel for="deviceType">{{ t('Type') }}</label>
              <select id="deviceType" cSelect formControlName="type">
                <option value="zoleo">{{ t('Zoleo') }}</option>
              </select>
            </c-col>
            <c-col md="6">
              <label cLabel for="deviceName">{{ t('Name') }} ({{ t('Optional') }})</label>
              <input id="deviceName" cFormControl formControlName="name" [placeholder]="t('Name')" />
              <small class="text-danger" *ngIf="deviceForm.controls.name.touched && deviceForm.controls.name.invalid">
                {{ t('Name must be at least 3 characters') }}
              </small>
            </c-col>
          </c-row>
          <c-row class="mb-2">
            <c-col md="6">
              <label cLabel for="deviceImei">{{ t('IMEI') }}</label>
              <input id="deviceImei" cFormControl formControlName="imei" [placeholder]="t('IMEI')" />
              <small class="text-danger" *ngIf="deviceForm.controls.imei.touched && deviceForm.controls.imei.invalid">
                {{ t('IMEI must be 15 digits') }}
              </small>
            </c-col>
            <c-col md="6">
              <label cLabel for="deviceNumber">{{ t('Phone Number') }}</label>
              <input id="deviceNumber" cFormControl formControlName="number" [placeholder]="t('Phone Number')" />
              <small class="text-danger" *ngIf="deviceForm.controls.number.touched && deviceForm.controls.number.invalid">
                {{ t('Please enter a valid phone number') }}
              </small>
            </c-col>
          </c-row>
          <div class="mt-2">
            <button cButton class="btn btn-info text-white me-2" type="submit" [disabled]="isSaving">
              <i class="fa-solid fa-floppy-disk"></i> {{ editingId ? t('Update Device') : t('Save Device') }}
            </button>
            <button cButton class="btn btn-light" type="button" (click)="cancelForm()">
              {{ t('Cancel') }}
            </button>
          </div>
        </form>
      </c-card-body>
    </c-card>

    <c-card class="mb-2">
      <c-card-body>
        <form cForm [formGroup]="filterForm" (ngSubmit)="updateFilter(true)">
          <c-row class="g-2 align-items-end">
            <c-col md="5">
              <label cLabel for="search">{{ t('Search') }}</label>
              <c-input-group>
                <span cInputGroupText><svg cIcon class="me-2" name="cil-search"></svg></span>
                <input id="search" cFormControl formControlName="search" [placeholder]="t('Search devices')" />
              </c-input-group>
            </c-col>
            <c-col md="3">
              <label cLabel for="sort">{{ t('Sort') }}</label>
              <select id="sort" cSelect formControlName="sort" (change)="updateFilter(true)">
                <option value="newest">{{ t('Newest') }}</option>
                <option value="oldest">{{ t('Oldest') }}</option>
                <option value="name">{{ t('Name') }}</option>
              </select>
            </c-col>
            <c-col md="4" class="text-end">
              <button cButton class="btn btn-light me-2" type="submit">
                <i class="fa-solid fa-magnifying-glass"></i> {{ t('Search') }}
              </button>
              <button cButton class="btn btn-light" type="button" (click)="clearFilter()">
                {{ t('Clear Filter') }}
              </button>
            </c-col>
          </c-row>
        </form>
      </c-card-body>
    </c-card>

    <c-row>
      <c-col>
        <table [hover]="true" [responsive]="true" [striped]="true" align="middle" cTable class="mb-0 border">
          <thead>
            <tr>
              <th scope="col">{{ t('Name') }}</th>
              <th scope="col">{{ t('Type') }}</th>
              <th scope="col">{{ t('IMEI') }}</th>
              <th scope="col">{{ t('Phone Number') }}</th>
              <th scope="col">{{ t('Created') }}</th>
              <th scope="col">{{ t('Actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let device of devices">
              <td>{{ device.name }}</td>
              <td>{{ device.type | fieldtitle }}</td>
              <td>{{ device.imei }}</td>
              <td>{{ device.number }}</td>
              <td>{{ device.created_at }}</td>
              <td>
                <button cButton class="btn btn-info btn-sm text-white me-1" type="button" (click)="openEditForm(device)">
                  <i class="fa-solid fa-pen"></i> {{ t('Edit') }}
                </button>
                <button cButton class="btn btn-danger btn-sm text-white" type="button" (click)="deleteDevice(device)">
                  <i class="fa-solid fa-trash"></i> {{ t('Delete') }}
                </button>
              </td>
            </tr>
            <tr *ngIf="devices.length === 0">
              <td colspan="6" class="text-center">{{ t('No devices found') }}</td>
            </tr>
          </tbody>
        </table>
      </c-col>
    </c-row>

    <c-row class="justify-content-end mt-2" *ngIf="pagination.totalPages > 1">
      <c-col xs="auto">
        <c-input-group class="text-end">
          <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
          <select aria-label="Default select example" name="page" cSelect [(ngModel)]="pagination.page" (change)="updateFilter(false)">
            <option *ngFor="let p of pagination.pageArray" value="{{ p }}">{{ p }}</option>
          </select>
        </c-input-group>
      </c-col>
    </c-row>
  </c-card-body>
</c-card>

<div class="modal fade" id="deviceUploadModal" tabindex="-1" aria-labelledby="deviceUploadModalLabel" aria-hidden="true" *transloco="let t">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deviceUploadModalLabel">{{ t('Upload Devices') }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-danger" *ngIf="uploadError">{{ uploadError }}</div>

        <div *ngIf="uploadStep === 1">
          <p>{{ t('Upload a CSV or Excel file with columns: Name, Type, IMEI, Phone Number.') }}</p>

          <div ng2FileDrop
               [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
               (fileOver)="fileOverBase($event)"
               [uploader]="uploader"
               class="well my-drop-zone mb-2"
               style="width:100%;height:120px;">
            {{ t('Drop your device upload file here or select it using the button below') }}
          </div>

          <input type="file" ng2FileSelect [uploader]="uploader" />

          <table class="table mt-3" *ngIf="uploader?.queue?.length">
            <thead>
              <tr>
                <th>{{ t('Name') }}</th>
                <th>{{ t('Size') }}</th>
                <th>{{ t('Progress') }}</th>
                <th>{{ t('Status') }}</th>
                <th>{{ t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of uploader.queue">
                <td><strong>{{ item?.file?.name }}</strong></td>
                <td *ngIf="uploader.options.isHTML5" nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                <td *ngIf="uploader.options.isHTML5">
                  <div class="progress mb-0">
                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                  </div>
                </td>
                <td>
                  <span *ngIf="item.isSuccess">{{ t('Uploaded') }}</span>
                  <span *ngIf="item.isError">{{ t('Error') }}</span>
                </td>
                <td>
                  <button type="button" class="btn btn-success btn-xs me-1" (click)="item.upload()" [disabled]="item.isUploading || item.isSuccess">
                    {{ t('Upload') }}
                  </button>
                  <button type="button" class="btn btn-warning btn-xs me-1" (click)="item.cancel()" [disabled]="!item.isUploading">
                    {{ t('Cancel') }}
                  </button>
                  <button type="button" class="btn btn-danger btn-xs" (click)="item.remove()">
                    {{ t('Remove') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="uploadStep === 2">
          <p>{{ t('Review device upload rows. Only rows with status New will be added.') }}</p>

          <div class="alert alert-info">
            {{ t('New') }}: {{ uploadSummary?.new || 0 }},
            {{ t('Already Present') }}: {{ uploadSummary?.already_present || 0 }},
            {{ t('Invalid') }}: {{ uploadSummary?.invalid || 0 }},
            {{ t('Duplicate') }}: {{ uploadSummary?.duplicate || 0 }}
          </div>

          <div class="text-center mb-2">
            <button type="button" class="btn btn-primary me-2" (click)="importDevices()" [disabled]="!canImport">
              <i class="fa-solid fa-file-import"></i> {{ t('Import New Devices') }}
            </button>
            <button type="button" class="btn btn-light" (click)="resetUpload()">
              <i class="fa-solid fa-angles-left"></i> {{ t('Upload Another File') }}
            </button>
          </div>

          <table [hover]="true" [responsive]="true" [striped]="true" align="middle" cTable class="mb-0 border">
            <thead>
              <tr>
                <th scope="col">{{ t('Row') }}</th>
                <th scope="col">{{ t('Status') }}</th>
                <th scope="col">{{ t('Name') }}</th>
                <th scope="col">{{ t('Type') }}</th>
                <th scope="col">{{ t('IMEI') }}</th>
                <th scope="col">{{ t('Phone Number') }}</th>
                <th scope="col">{{ t('Errors') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of uploadRows">
                <td>{{ row.row }}</td>
                <td><span class="badge" [ngClass]="statusBadge(row.status)">{{ t(statusLabel(row.status)) }}</span></td>
                <td>{{ row.name }}</td>
                <td>{{ row.type | fieldtitle }}</td>
                <td>{{ row.imei }}</td>
                <td>{{ row.number }}</td>
                <td>
                  <ul *ngIf="row.errors?.length" class="text-danger mb-0">
                    <li *ngFor="let err of row.errors">{{ err }}</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="uploadStep === 3">
          <div class="alert alert-success">
            {{ t('Device upload completed. Created:') }} {{ importSummary?.created || 0 }}
          </div>

          <table [hover]="true" [responsive]="true" [striped]="true" align="middle" cTable class="mb-0 border">
            <thead>
              <tr>
                <th scope="col">{{ t('Row') }}</th>
                <th scope="col">{{ t('Status') }}</th>
                <th scope="col">{{ t('Name') }}</th>
                <th scope="col">{{ t('IMEI') }}</th>
                <th scope="col">{{ t('Phone Number') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of importSummary?.results || []">
                <td>{{ row.row }}</td>
                <td><span class="badge" [ngClass]="statusBadge(row.status)">{{ t(statusLabel(row.status)) }}</span></td>
                <td>{{ row.name }}</td>
                <td>{{ row.imei }}</td>
                <td>{{ row.number }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">{{ t('Close') }}</button>
      </div>
    </div>
  </div>
</div>
